import { useCallback, useEffect, useState } from "react";
import CharityEventTypeService from "../../../services/CharityEventTypeService";
import { CharityEventType } from "../../../models";
import CharityEventTypesTable from "./ui/charity-event-types-table";
import CharityEventTypesTableSkeleton from "./skeletons/charity-event-types-table-skeleton";

export default function CharityEventTypesPage() {
  const api = new CharityEventTypeService();
  const [items, setItems] = useState<CharityEventType[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchItems = useCallback(async (showLoading = false) => {
    try {
      if (showLoading) setLoading(true);
      const data = await api.getCharityEventTypes();
      setItems(data);
    } catch (err) {
      console.error("Error fetching charity event types:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void fetchItems(true);
  }, [fetchItems]);

  return (
    <div className="w-full">
      <div className="flex w-full items-center justify-between">
        <h1 className={` text-2xl`}>Charity Event Types</h1>
      </div>
      {loading ? (
        <CharityEventTypesTableSkeleton />
      ) : (
        <CharityEventTypesTable items={items} loading={loading} onChanged={fetchItems} />
      )}
    </div>
  );
}
